import styles from '../../page.module.scss';
import Typeo from './Typeo';

export default function HistoriaSection() {
  return (
    <div>
      <section id="historia" className={styles.historiaContainer}>
        <br /> <br />
        <div className={styles.historiaContent}>
          <h2 className={styles.title}>¿Quiénes somos?</h2>
          <p className={styles.text}>
            El proyecto editorial de La Libre nace hace diez años de los vínculos que fueron
            brotando desde la librería, de las lecturas, escrituras e intercambios que surgieron en
            el espacio físico ubicado en San Telmo. En el 2012 hicimos nuestra primera publicación
            con la novela La ciudad ambulante de Dario Semino, ex librero y socio de la cooperativa.
          </p>
          <br />
          <p className={styles.text}>
            Los títulos que componen nuestro catálogo fueron seleccionados por diversas causas, en
            el camino fuimos encontrando los libros que queríamos publicar. Nuestro criterio quizás
            haya sido publicar libros que consideramos joyitas, de esas que en nuestra librería
            abundan: voces marginales, que cuestionan el canon, libros raros, formatos novedosos,
            ideas explosivas y poéticas necesarias que no tienen espacio en otras editoriales. Esas
            elecciones también se basaron en lazos preexistentes con les autores, con quienes
            trabajamos de forma horizontal, en diálogo, reforzando la idea de trabajo colectivo y
            cooperativo que forma parte fundamental del espíritu de La Libre.
          </p>
        </div>
        <img
          className={styles.historiaImage}
          src={'/assets/images/historia.png'}
          alt="imagen de la sección"
        />
      </section>
      <Typeo />
    </div>
  );
}
